<template>
  <v-form ref="formFiltro">
    <v-card class="px-6 py-3 br-15 w-100" elevation="0">
      <v-row>
        <v-col class="d-flex" cols="4">
          <v-toolbar-title class="page-title">Extrato </v-toolbar-title>
          <div class="ma-1">
            <InfoBox expands>
              <p>
                No extrato é possivel visualizar o resumo dos investimentos por
                fornecedor. Também é possivel visualizar os acordos de forma
                detalhada, trazendo lojas e produtos e essas informações estão
                nas sheets "verba e vb". No extrato atual temos as informações
                do PDV, ecommerce, campanha e negociação comercial.
              </p>
            </InfoBox>
          </div>
        </v-col>
        <v-col cols="4" class="pb-0">
          <MesInput
            label="Mês"
            v-model="filtro.mesInicial"
            :rules="usuarioTipo == 'fornecedor' && regra.mesInicial"
            :max="filtroMesMaximo"
          />
        </v-col>

        <!-- <v-col cols="3" class="pb-0">
                    <MesInput
                        label="Período Final"
                        v-model="filtro.mesFinal"
                        :rules="regra.mesFinal"
                    />
                </v-col> -->
        <v-col cols="4" class="pb-0">
          <v-autocomplete
            label="Fornecedor"
            v-model="filtro.id_fornecedor"
            :items="lista.fornecedor"
            :rules="regra.fornecedor"
            outlined
            dense
            class="input-cinza"
            :menu-props="menuProps"
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <div
                v-if="filtro.id_fornecedor.length === 1 && index === 0"
                class="autocomplete-selecao"
              >
                {{ item.text }}
              </div>
              <span
                v-if="filtro.id_fornecedor.length > 1 && index === 0"
                class="grey--text caption mr-1"
                >{{ filtro.id_fornecedor.length }} selecionados</span
              >
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="px-3 pb-3" align="end">
          <v-btn
            class="ml-4 px-8 new-button"
            color="yellow"
            dark
            @click="limpar()"
          >
            <v-icon left>mdi-filter-off</v-icon> Limpar
          </v-btn>
          <v-btn
            class="ml-5 px-8 new-button"
            color="primary"
            @click="filtrar()"
          >
            <v-icon left>mdi-filter</v-icon> Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-overlay :value="overlay" :z-index="300">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-form>
</template>

<script>
import InfoBox from "../../../components/InfoBox.vue";
import MesInput from "../../../components/MesInput.vue";
import useFiltros from "../../../hooks/useFiltros";

export default {
  setup() {
    const {
      isLoading,
      isError,
      isFetching,
      lista,
      error,
      refetch,
    } = useFiltros("/gerencial/filtros");

    return { isLoading, isError, isFetching, lista, error, refetch };
  },
  components: {
    MesInput,
    InfoBox,
  },
  data() {
    return {
      menuProps: {
        bottom: true,
        offsetY: true,
        contentClass: "select-outline",
        transition: "slide-y-transition",
      },
      filtro: {},
      regra: {
        mesInicial: [
          (v) => !!v || "Selecione um período inicial para o filtro",
          // if usuarioTipo is equal "fornecedor" then mesInicial should be before or equal to last month
          (v) =>
            (!!v &&
              this.$moment(this.filtro.mesInicial, "YYYY-MM") <
                this.$moment()) ||
            "O  mes selecionado deve ser igual ou anterior ao mês anterior.",
        ],
        mesFinal: [
          (v) => !!v || "Selecione um período final para o filtro",
          (v) =>
            (!!v && v >= this.filtro.mesInicial) ||
            "O período final deve ser igual ou posterior ao período inicial",
        ],
        fornecedor: [(v) => !!v || "O campo fornecedor é obrigatório"],
      },
    };
  },
  beforeMount() {
    this.iniciaFiltro();
  },
  computed: {
    overlay() {
      return Object.keys(this.lista).length === 0 && this.isFetching;
    },
    usuarioTipo() {
      if (this.$store.getters.getUsuario.id_fornecedor) {
        return "fornecedor";
      }
      return "rd";
    },
    filtroMesMaximo() {
      if (this.usuarioTipo === "fornecedor") {
        return this.$moment()
        //   .subtract(1, "months")
          .format("YYYY-MM");
      }
      return null;
    },
  },

  methods: {
    iniciaFiltro() {
      this.filtro = {
        mesInicial: this.$moment().format("YYYY-MM"),
        mesFinal: this.$moment().format("YYYY-MM"),
        id_fornecedor: [],
      };

      if (this.usuarioTipo === "fornecedor") {
        this.filtro.mesInicial = this.$moment()
        //   .subtract(1, "months")
          .format("YYYY-MM");

        if (this.lista.fornecedor && this.lista.fornecedor.length === 1) {
          this.filtro.id_fornecedor = [this.lista.fornecedor[0].value];
        }
      }

      this.resetValidation();
    },
    limpar() {
      this.iniciaFiltro();
    },
    filtrar() {
      if (!this.validate()) return;

      this.$emit("filtrar");
    },
    validate() {
      return this.$refs.formFiltro.validate();
    },
    resetValidation() {
      try {
        this.$refs.formFiltro.resetValidation();
      } catch (error) {
        //console.log(error)
      }
    },
  },
  watch: {
    "lista.fornecedor": function() {
      if (this.usuarioTipo === "fornecedor" && this.filtro.id_fornecedor.length === 0) {
        this.iniciaFiltro();
      }
    },
    "filtro.id_fornecedor": {
      handler(newVal) {
        this.$emit("fornecedor-change", newVal && newVal.length > 0);
      },
      deep: true,
    },
  },
};
</script>
